import { ToastProvider } from "@/ds";
import { SimulacaoProvider } from "@/modules/recursos/simulacao";

import { useCargaDeTrabalho } from "./use-carga-de-trabalho";
import { CargaDeTrabalhoView } from "./view-carga-de-trabalho";

function CargaDeTrabalhoLigada() {
  const vm = useCargaDeTrabalho();

  return <CargaDeTrabalhoView {...vm} />;
}

export function CargaDeTrabalhoScreen() {
  return (
    <ToastProvider position="top-right">
      <SimulacaoProvider>
        <CargaDeTrabalhoLigada />
      </SimulacaoProvider>
    </ToastProvider>
  );
}

export type * from "./types-carga-de-trabalho";
